(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7966],{

/***/ 682:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account",
      function () {
        return __webpack_require__(59079);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 37710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_cinderblocks_growth_auth_LocalizationContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24773);
/* harmony import */ var _opendoor_cinderblocks_platform_auth_AccountForm__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69586);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74593);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var helpers_useLocale__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37680);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67945);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35480);
/* harmony import */ var _shared_AccountConnector__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45949);














var Sentry = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .globalObservability.getSentryClient */ .w.getSentryClient();
var UNAUTHORIZED_STATUS_CODE = 401;
var AccountFormPage = function(param) {
    var logIn = param.logIn, register = param.register, requestHumanStatus = param.requestHumanStatus, hasGeneratedPassword = param.hasGeneratedPassword, _isNewHuman = param.isNewHuman, isNewHuman = _isNewHuman === void 0 ? false : _isNewHuman, loginRequestStatus = param.loginRequestStatus, humanStatusRequestStatus = param.humanStatusRequestStatus, registrationRequestStatus = param.registrationRequestStatus, config = param.config, email = param.email, emailPrefill = param.emailPrefill, requestResetPassword = param.requestResetPassword, redirectTo = param.redirectTo, maybeFetchSessionInfo = param.maybeFetchSessionInfo, loggedIn = param.loggedIn, serverLoginRedirect = param.serverLoginRedirect, updatedPassword = param.updatedPassword;
    var locale = (0,helpers_useLocale__WEBPACK_IMPORTED_MODULE_5__/* .useLocale */ .b)();
    var getSignInText = function(config) {
        var loginHeaderText;
        var registrationHeaderText;
        switch(config){
            case "resaleClosingDashboard":
                loginHeaderText = "Sign in to get back to your dashboard";
                registrationHeaderText = "Sign up to get access to your dashboard";
                break;
            default:
                break;
        }
        return {
            loginHeaderText: loginHeaderText,
            registrationHeaderText: registrationHeaderText
        };
    };
    var ref = getSignInText(config), loginHeaderText = ref.loginHeaderText, registrationHeaderText = ref.registrationHeaderText;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .analytics.register */ .co.register({
            login: js_cookie__WEBPACK_IMPORTED_MODULE_4___default().get("login-test") || "no-cookie"
        });
        _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .analytics.trackEvent */ .co.trackEvent("login", "load", undefined, {
            email: email,
            config: config,
            redirectTo: redirectTo,
            emailPrefill: emailPrefill
        });
        maybeFetchSessionInfo();
        redirectIfLoggedIn();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        redirectIfLoggedIn();
        if (loginRequestStatus && loginRequestStatus.error && loginRequestStatus.statusCode !== UNAUTHORIZED_STATUS_CODE) {
            var ref;
            (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, loginRequestStatus.error);
        }
    }, [
        loggedIn,
        loginRequestStatus
    ]);
    var trackLoginEvent = function(topic, label, extra) {
        _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .analytics.trackEvent */ .co.trackEvent("login", topic, label, extra);
    };
    var redirectIfLoggedIn = function() {
        if (loggedIn) {
            _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .analytics.trackEvent */ .co.trackEvent("login", "redirect", undefined, {
                email: email,
                config: config,
                redirectTo: redirectTo,
                serverLoginRedirect: serverLoginRedirect
            });
            var redirectUrl;
            if (!redirectTo && serverLoginRedirect && serverLoginRedirect !== "/") {
                redirectUrl = serverLoginRedirect;
            } else if (redirectTo) {
                // allow redirection to relative urls & opendoor.com absolute urls
                if (_globals__WEBPACK_IMPORTED_MODULE_7__/* .REDIRECT_URLS_REGEX.test */ .Ut.test(redirectTo)) {
                    // absolute path
                    redirectUrl = redirectTo;
                } else {
                    // if redirectTo does not match regex it is a relative path
                    // add `/` to enforce relative only if it does not already have one
                    redirectUrl = "".concat(redirectTo[0] === "/" ? "" : "/").concat(redirectTo);
                }
            }
            window.location.assign(redirectUrl || "/");
        }
    };
    var handlePasswordlessLoginRequest = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(email) {
            var response, errors;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        trackLoginEvent("one-time-password", "request", {
                            email: email,
                            redirectTo: redirectTo
                        });
                        return [
                            4,
                            _api__WEBPACK_IMPORTED_MODULE_6__/* .requestNewTokenByEmail */ .fs(email, redirectTo)
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response || !response.data || response.errors) {
                            errors = response && response.errors;
                            trackLoginEvent("one-time-password", "error", {
                                email: email,
                                errors: errors
                            });
                            return [
                                2,
                                {
                                    success: false,
                                    errors: errors
                                }
                            ];
                        }
                        trackLoginEvent("one-time-password", "success", {
                            email: email
                        });
                        return [
                            2,
                            {
                                success: true
                            }
                        ];
                }
            });
        });
        return function handlePasswordlessLoginRequest(email) {
            return _ref.apply(this, arguments);
        };
    }();
    var headerText = loginHeaderText;
    if (updatedPassword) {
        headerText = "Your password was successfully changed. Please sign in.";
    }
    var onRegister = function(email, name, password, phone, googleIDToken) {
        register(email, name, password, phone, googleIDToken);
        //   Do not remove - GTM event for account creation
        _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .analytics.trackEvent */ .co.trackEvent("session", "register", "account-creation", {
            email: email
        });
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__/* .Box */ .x, {
        py: "$24x",
        px: "$12x",
        mx: "auto",
        justifyContent: "center",
        alignItems: "center",
        $largerThanMD: {
            py: "$36x",
            px: 0
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_opendoor_cinderblocks_growth_auth_LocalizationContext__WEBPACK_IMPORTED_MODULE_1__/* .LocalizationProvider */ ._, {
            locale: locale,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_opendoor_cinderblocks_platform_auth_AccountForm__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                analyticsName: "cosmos-account-form",
                loginHeaderText: headerText,
                registrationHeaderText: registrationHeaderText,
                email: email || emailPrefill,
                hasGeneratedPassword: hasGeneratedPassword,
                error: loginRequestStatus.error || humanStatusRequestStatus.error || registrationRequestStatus.error,
                passwordLoading: !!serverLoginRedirect || loginRequestStatus.isLoading || registrationRequestStatus.isLoading,
                emailLoading: humanStatusRequestStatus.isLoading,
                isNewHuman: isNewHuman,
                onLogin: logIn,
                overrideHasSubmittedEmailCheckForLogin: !!emailPrefill,
                onRegister: onRegister,
                onHumanStatusRequest: requestHumanStatus,
                showGoogleAuth: true,
                requestResetPassword: requestResetPassword,
                onPasswordlessLoginRequest: function(email) {
                    return handlePasswordlessLoginRequest(email);
                }
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,_shared_AccountConnector__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(AccountFormPage));


/***/ }),

/***/ 45949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports AccountConnector, AccountContext, AccountContextProvider, useAccountContext */
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15467);
/* harmony import */ var _opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5515);
/* harmony import */ var _opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29884);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42279);







var mapStateToProps = (0,reselect__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)([
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__.human,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__.infoIsLoaded,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__.infoIsLoading,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__.loggedIn,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__.loginRequestStatus,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__.humanStatusRequestStatus,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__.registrationRequestStatus,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__.serverLoginRedirect,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__.email,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__.hasGeneratedPassword,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__.isNewHuman, 
], function(human, infoIsLoaded, infoIsLoading, loggedIn, loginRequestStatus, humanStatusRequestStatus, registrationRequestStatus, serverLoginRedirect, email, hasGeneratedPassword, isNewHuman) {
    return {
        human: human,
        infoIsLoaded: infoIsLoaded,
        infoIsLoading: infoIsLoading,
        loggedIn: loggedIn,
        loginRequestStatus: loginRequestStatus,
        humanStatusRequestStatus: humanStatusRequestStatus,
        registrationRequestStatus: registrationRequestStatus,
        serverLoginRedirect: serverLoginRedirect,
        email: email,
        hasGeneratedPassword: hasGeneratedPassword,
        isNewHuman: isNewHuman
    };
});
var mapDispatchToProps = function(dispatch) {
    return {
        maybeFetchSessionInfo: function() {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_2__.maybeFetchSessionInfo());
        },
        maybeLogOut: function() {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_2__.maybeLogOut());
        },
        logIn: function(email, password, googleIDToken, facebookIDToken) {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_2__.logIn(email, password, googleIDToken, facebookIDToken));
        },
        requestHumanStatus: function(email) {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_2__.requestHumanStatus(email));
        },
        requestResetPassword: function(email) {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_2__.requestPasswordReset(email));
        },
        register: function(email, name, password, phone, googleIDToken, facebookIDToken, passwordlessToken, hasGeneratedPassword, redirectUrl) {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_2__.register(email, name, password, phone, googleIDToken, facebookIDToken, passwordlessToken, hasGeneratedPassword, redirectUrl));
        }
    };
};
/**
 * This is an HOC that provides access to the session state via props
 *
 * @deprecated Use @opendoor/auth-fe::useAuth instead
 */ var AccountConnector = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps);
/* harmony default export */ __webpack_exports__["ZP"] = (AccountConnector);
var AccountContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
/**
 * This is a wrapper around the AccountConnector that provides access via context
 *
 * @deprecated Use @opendoor/auth-fe::useAuth instead
 */ var AccountContextProvider = AccountConnector(function(_param) {
    var children = _param.children, accountProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(AccountContext.Provider, {
        value: accountProps,
        children: children
    });
});
/**
 * This is a helper hook to access AccountContext
 *
 * @deprecated Use @opendoor/auth-fe::useAuth instead
 */ function useAccountContext() {
    return useContext(AccountContext);
}


/***/ }),

/***/ 3542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35944);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15467);
/* harmony import */ var _opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26198);
/* harmony import */ var _opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _opendoor_shared_fe_build_sagas__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47219);
/* harmony import */ var _opendoor_shared_fe_build_store_session__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95718);
/* harmony import */ var _opendoor_shared_fe_build_store_session__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_opendoor_shared_fe_build_store_session__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _opendoor_shared_fe_build_store_session_saga__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4544);
/* harmony import */ var _opendoor_shared_fe_build_store_session_saga__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_opendoor_shared_fe_build_store_session_saga__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21597);
/* harmony import */ var redux_immutable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72739);
/* harmony import */ var redux_saga__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87200);
/* harmony import */ var redux_saga_effects__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92242);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35480);













var sagas = function sagas() {
    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_8__.all)([
                        (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_8__.fork)(new (_opendoor_shared_fe_build_store_session_saga__WEBPACK_IMPORTED_MODULE_4___default())(new (_opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_1___default())(_globals__WEBPACK_IMPORTED_MODULE_9__/* .XSRF_COOKIE_KEY */ .x0, _globals__WEBPACK_IMPORTED_MODULE_9__/* .RAILS_URL */ .oF)).saga)
                    ])
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
};
var sagaMiddleware = (0,redux_saga__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)({
    onError: _opendoor_shared_fe_build_sagas__WEBPACK_IMPORTED_MODULE_2__/* .sagaMiddlewareErrorHandler */ .e
});
var composeEnhancers = ( true && window).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux__WEBPACK_IMPORTED_MODULE_5__/* .compose */ .qC;
var reducers = {
    session: (_opendoor_shared_fe_build_store_session__WEBPACK_IMPORTED_MODULE_3___default().reducer)
};
var store = (0,redux__WEBPACK_IMPORTED_MODULE_5__/* .createStore */ .MT)((0,redux_immutable__WEBPACK_IMPORTED_MODULE_6__/* .combineReducers */ .U)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, reducers)), undefined, composeEnhancers((0,redux__WEBPACK_IMPORTED_MODULE_5__/* .applyMiddleware */ .md)(sagaMiddleware)));
sagaMiddleware.run(sagas);
var ReduxWrapper = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(react_redux__WEBPACK_IMPORTED_MODULE_0__/* .Provider */ .zt, {
        store: store,
        children: props.children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReduxWrapper);


/***/ }),

/***/ 59079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_account_AccountFormPage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37710);
/* harmony import */ var _components_shared_ReduxWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3542);
/* harmony import */ var _shared_LandingPageV2Layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66131);








var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,next_router__WEBPACK_IMPORTED_MODULE_1__.withRouter)(function(context) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_shared_ReduxWrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_shared_LandingPageV2Layout__WEBPACK_IMPORTED_MODULE_4__["default"], (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, context), {
            hideGoogleOneTap: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_account_AccountFormPage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, context.router.query))
        }))
    });
}));


/***/ }),

/***/ 24773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ LocalizationProvider; }
/* harmony export */ });
/* unused harmony export useLocalization */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77601);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67294);
/* harmony import */ var _i18n_index_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56978);













function cov_1x2xuaq99b() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/growth/auth/LocalizationContext.tsx";
    var hash = "31c57441b2debfd5092b25a97ab88aa07e203228";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/growth/auth/LocalizationContext.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 11,
                    column: 28
                },
                end: {
                    line: 14,
                    column: 2
                }
            },
            "1": {
                start: {
                    line: 16,
                    column: 85
                },
                end: {
                    line: 38,
                    column: 1
                }
            },
            "2": {
                start: {
                    line: 20,
                    column: 28
                },
                end: {
                    line: 20,
                    column: 62
                }
            },
            "3": {
                start: {
                    line: 22,
                    column: 2
                },
                end: {
                    line: 29,
                    column: 15
                }
            },
            "4": {
                start: {
                    line: 23,
                    column: 4
                },
                end: {
                    line: 28,
                    column: 5
                }
            },
            "5": {
                start: {
                    line: 24,
                    column: 6
                },
                end: {
                    line: 24,
                    column: 22
                }
            },
            "6": {
                start: {
                    line: 25,
                    column: 6
                },
                end: {
                    line: 25,
                    column: 61
                }
            },
            "7": {
                start: {
                    line: 25,
                    column: 45
                },
                end: {
                    line: 25,
                    column: 59
                }
            },
            "8": {
                start: {
                    line: 27,
                    column: 6
                },
                end: {
                    line: 27,
                    column: 21
                }
            },
            "9": {
                start: {
                    line: 31,
                    column: 2
                },
                end: {
                    line: 31,
                    column: 26
                }
            },
            "10": {
                start: {
                    line: 31,
                    column: 14
                },
                end: {
                    line: 31,
                    column: 26
                }
            },
            "11": {
                start: {
                    line: 33,
                    column: 2
                },
                end: {
                    line: 37,
                    column: 4
                }
            },
            "12": {
                start: {
                    line: 40,
                    column: 31
                },
                end: {
                    line: 40,
                    column: 68
                }
            },
            "13": {
                start: {
                    line: 40,
                    column: 37
                },
                end: {
                    line: 40,
                    column: 68
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 16,
                        column: 85
                    },
                    end: {
                        line: 16,
                        column: 86
                    }
                },
                loc: {
                    start: {
                        line: 19,
                        column: 6
                    },
                    end: {
                        line: 38,
                        column: 1
                    }
                },
                line: 19
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 22,
                        column: 12
                    },
                    end: {
                        line: 22,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 18
                    },
                    end: {
                        line: 29,
                        column: 3
                    }
                },
                line: 22
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 25,
                        column: 39
                    },
                    end: {
                        line: 25,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 45
                    },
                    end: {
                        line: 25,
                        column: 59
                    }
                },
                line: 25
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 40,
                        column: 31
                    },
                    end: {
                        line: 40,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 37
                    },
                    end: {
                        line: 40,
                        column: 68
                    }
                },
                line: 40
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 23,
                        column: 4
                    },
                    end: {
                        line: 28,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 23,
                            column: 4
                        },
                        end: {
                            line: 28,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 26,
                            column: 11
                        },
                        end: {
                            line: 28,
                            column: 5
                        }
                    }
                ],
                line: 23
            },
            "1": {
                loc: {
                    start: {
                        line: 31,
                        column: 2
                    },
                    end: {
                        line: 31,
                        column: 26
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 31,
                            column: 2
                        },
                        end: {
                            line: 31,
                            column: 26
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 31
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "31c57441b2debfd5092b25a97ab88aa07e203228"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_1x2xuaq99b = function cov_1x2xuaq99b() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_1x2xuaq99b();
function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r1) {
            o = !0, n = r1;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}


var LocalizationContext = (cov_1x2xuaq99b().s[0]++, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_13__.createContext)({
    locale: "en-US",
    ready: false
}));
cov_1x2xuaq99b().s[1]++;
var LocalizationProvider = function LocalizationProvider(_ref) {
    var locale = _ref.locale, children = _ref.children;
    cov_1x2xuaq99b().f[0]++;
    var _ref2 = (cov_1x2xuaq99b().s[2]++, (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)(_i18n_index_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"].language */ .Z.language === locale)), _ref3 = _slicedToArray(_ref2, 2), ready = _ref3[0], setReady = _ref3[1];
    cov_1x2xuaq99b().s[3]++;
    (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function() {
        cov_1x2xuaq99b().f[1]++;
        cov_1x2xuaq99b().s[4]++;
        if (_i18n_index_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"].language */ .Z.language !== locale) {
            cov_1x2xuaq99b().b[0][0]++;
            cov_1x2xuaq99b().s[5]++;
            setReady(false);
            cov_1x2xuaq99b().s[6]++;
            _i18n_index_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"].changeLanguage */ .Z.changeLanguage(locale).then(function() {
                cov_1x2xuaq99b().f[2]++;
                cov_1x2xuaq99b().s[7]++;
                return setReady(true);
            });
        } else {
            cov_1x2xuaq99b().b[0][1]++;
            cov_1x2xuaq99b().s[8]++;
            setReady(true);
        }
    }, [
        locale
    ]);
    cov_1x2xuaq99b().s[9]++;
    if (!ready) {
        cov_1x2xuaq99b().b[1][0]++;
        cov_1x2xuaq99b().s[10]++;
        return null;
    } else {
        cov_1x2xuaq99b().b[1][1]++;
    }
    cov_1x2xuaq99b().s[11]++;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_13__.createElement(LocalizationContext.Provider, {
        value: {
            locale: locale,
            ready: ready
        }
    }, children);
};
cov_1x2xuaq99b().s[12]++;
var useLocalization = function useLocalization() {
    cov_1x2xuaq99b().f[3]++;
    cov_1x2xuaq99b().s[13]++;
    return useContext(LocalizationContext);
}; //# sourceMappingURL=LocalizationContext.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5336,9842,2767,6500,5662,7166,3089,4638,9331,5569,523,5527,4897,6937,7014,7194,5369,5675,2864,8764,4746,5663,4370,7890,9593,2283,2190,7663,9712,1817,9586,8058,2149,1462,5040,8834,6131,9774,2888,179], function() { return __webpack_exec__(682); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);